(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Analytics", [], factory);
	else if(typeof exports === 'object')
		exports["Analytics"] = factory();
	else
		root["Analytics"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var analytics_1 = __webpack_require__(1);
exports.Analytics = analytics_1.Analytics;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var segment_1 = __webpack_require__(2);
var ensighten_1 = __webpack_require__(4);
var store_1 = __webpack_require__(5);
var Analytics = /** @class */ (function () {
    function Analytics(options) {
        var _this = this;
        this.options = options;
        this.providers = [];
        this.store = new store_1.Store();
        this._providers = {
            segment: new segment_1.SegmentAnalyitcs(this.store),
            ensighten: new ensighten_1.EnsightenAnalytics()
        };
        if (this.options) {
            this.options.use.forEach(function (provider) {
                if (!_this._providers[provider].test()) {
                    throw "The provider " + provider + " is not installed in the application";
                }
                _this.providers.push(provider);
            });
        }
        if (this.providers.length === 0) {
            this.providers.push("segment");
        }
    }
    Analytics.prototype.group = function (groupId, traits) {
        var _this = this;
        this.providers.forEach(function (provider) {
            _this._providers[provider].group(groupId, traits);
        });
    };
    Analytics.prototype.identify = function (userId, userProperties, isLazy) {
        var _this = this;
        this.providers.forEach(function (provider) {
            _this._providers[provider].identify(userId, userProperties, isLazy);
        });
    };
    Analytics.prototype.track = function (eventName, eventProperties, isLazy) {
        var _this = this;
        this.providers.forEach(function (provider) {
            _this._providers[provider].track(eventName, eventProperties, isLazy);
        });
    };
    Analytics.prototype.alias = function (userId, previousId) {
        var _this = this;
        this.providers.forEach(function (provider) {
            _this._providers[provider].alias(userId, previousId);
        });
    };
    Analytics.prototype.page = function (category, name, properties) {
        var _this = this;
        this.providers.forEach(function (provider) {
            _this._providers[provider].page(category, name, properties);
        });
    };
    Analytics.prototype.clearPendingCalls = function () {
        var _this = this;
        this.providers.forEach(function (provider) {
            if (_this._providers[provider].clearPendingCalls) {
                _this._providers[provider].clearPendingCalls();
            }
        });
    };
    return Analytics;
}());
exports.Analytics = Analytics;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var analytics_model_1 = __webpack_require__(3);
var PENDING_TRACK_CALLS_KEY = "LC:PendingTrackCalls";
var PENDING_IDENTIFY_CALLS_KEY = "LC:PendingIdentifyCalls";
var STORAGE_KEYS = {
    track: PENDING_TRACK_CALLS_KEY,
    identify: PENDING_IDENTIFY_CALLS_KEY
};
var runPendingCalls = function (store, type) {
    var pendingCalls = JSON.parse(store.read(STORAGE_KEYS[type]));
    if (pendingCalls && pendingCalls.length) {
        switch (type) {
            case analytics_model_1.CallType.Track:
                pendingCalls.forEach(function (pendingCall) {
                    window.analytics.track(pendingCall.eventName, pendingCall.eventProperties);
                });
                break;
            case analytics_model_1.CallType.Identify:
                pendingCalls.forEach(function (pendingCall) {
                    window.analytics.identify(pendingCall.userId, pendingCall.userProperties);
                });
                break;
        }
        store.remove(STORAGE_KEYS[type]);
    }
};
var registerPendingCall = function (store, type, callObj) {
    var pendingCalls = JSON.parse(store.read(STORAGE_KEYS[type]));
    pendingCalls ? pendingCalls.push(callObj) : (pendingCalls = [callObj]);
    store.write(STORAGE_KEYS[type], JSON.stringify(pendingCalls));
};
var SegmentAnalyitcs = /** @class */ (function () {
    function SegmentAnalyitcs(store) {
        this.store = store;
        runPendingCalls(store, "track");
        runPendingCalls(store, "identify");
    }
    SegmentAnalyitcs.prototype.test = function () {
        var analytics = window.analytics;
        if (typeof analytics === "undefined")
            return false;
        return ((typeof analytics === "object" && analytics.Integrations) ||
            (analytics.methods && typeof analytics.Integrations === "object") ||
            typeof analytics.methods === "object");
    };
    SegmentAnalyitcs.prototype.identify = function (userId, userProperties, isLazy) {
        isLazy
            ? registerPendingCall(this.store, "identify", { userId: userId, userProperties: userProperties })
            : window.analytics.identify(userId, userProperties);
    };
    SegmentAnalyitcs.prototype.track = function (eventName, eventProperties, isLazy) {
        isLazy
            ? registerPendingCall(this.store, "track", { eventName: eventName, eventProperties: eventProperties })
            : window.analytics.track(eventName, eventProperties);
    };
    SegmentAnalyitcs.prototype.page = function (category, name, properties) {
        window.analytics.page(category, name, properties);
    };
    SegmentAnalyitcs.prototype.alias = function (userId, previousId) {
        window.analytics.alias(userId, previousId);
    };
    SegmentAnalyitcs.prototype.group = function (groupId, traits) {
        window.analytics.group(groupId, traits);
    };
    SegmentAnalyitcs.prototype.clearPendingCalls = function () {
        var _this = this;
        Object.keys(STORAGE_KEYS).forEach(function (key) {
            _this.store.remove(STORAGE_KEYS[key]);
        });
    };
    return SegmentAnalyitcs;
}());
exports.SegmentAnalyitcs = SegmentAnalyitcs;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CallType;
(function (CallType) {
    CallType["Track"] = "track";
    CallType["Identify"] = "identify";
    CallType["Page"] = "page";
})(CallType = exports.CallType || (exports.CallType = {}));


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EnsightenAnalytics = /** @class */ (function () {
    function EnsightenAnalytics() {
    }
    EnsightenAnalytics.prototype.test = function () {
        var webAnalytics = window.webAnalytics;
        return !!webAnalytics && !!webAnalytics.publish;
    };
    EnsightenAnalytics.prototype.track = function (eventName, eventProperties) {
        var dataLayer = window.dataLayer;
        if (eventName === "productSet") {
            dataLayer[eventName] = eventProperties;
        }
    };
    EnsightenAnalytics.prototype.identify = function () { };
    EnsightenAnalytics.prototype.page = function () { };
    EnsightenAnalytics.prototype.alias = function () { };
    EnsightenAnalytics.prototype.group = function () { };
    return EnsightenAnalytics;
}());
exports.EnsightenAnalytics = EnsightenAnalytics;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Store = /** @class */ (function () {
    function Store() {
    }
    Store.prototype.read = function (key) {
        return window.localStorage.getItem(key);
    };
    Store.prototype.write = function (key, val) {
        window.localStorage.setItem(key, val);
    };
    Store.prototype.remove = function (key) {
        window.localStorage.removeItem(key);
    };
    Store.prototype.clearAll = function () {
        window.localStorage.clear();
    };
    return Store;
}());
exports.Store = Store;


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// analytics.min.js